import React from 'react';
import "../style/Product_page.css";

const Product_page = () => {
    return (
        <div className='Product_page'>
            <div className='Product_page_img'>
                <div>
                    <div className='Product_page_img1'></div>
                    <h4>ROTARY CUTTING AND CREASING MACHINE</h4>
                </div>
                <div>
                    <div className='Product_page_img2'></div>
                    <h4>
                        RS4 TWO COLOUR PRINTER<br/>
                        DIE CUTTING AND SLOTTER MACHINE
                    </h4>
                </div>
                <div>
                    <div className='Product_page_img3'></div>
                    <h4>CORRUGATION MACHINE</h4>
                </div>
                <div>
                    <div className='Product_page_img4'></div>
                    <h4>THREE PLY BOARD CONVEYOR UNIT FRONT VIEW</h4>
                </div>
                <div>
                    <div className='Product_page_img5'></div>
                    <h4>THREE PLY BOARD CONVEYOR UNIT REAR VIEW</h4>
                </div>
                <div>
                    <div className='Product_page_img6'></div>
                    <h4>DIE PUNCHING MACHINE</h4>
                </div>
            </div>
        </div>
    );
}

export default Product_page;
